import { Typography } from '@mui/material'
import { PrincipalLayouts } from '../../layouts/PrincipalLayouts'

export const Funds = () => {
    return (
        <PrincipalLayouts>
            <Typography color='primary' variant='h6'>Fondos</Typography>
        </PrincipalLayouts>
    )
}
